import Modal from "common/components/Modal";
import axios from "common/configs/axiosConfigs";
import React, { useState } from "react";
import { toast } from "react-toastify";

const AddFollowup = ({ onClose, isOpen, setFollowups, leadId }) => {
  const companyId = JSON.parse(localStorage.getItem("user-auth"))?.company_id;

  const [formState, setFormState] = useState({ schedule: new Date() });
  const handleInput = ({ target: { name, value } }) => {
    setFormState((prev) => ({ ...prev, [name]: value }));
  };
  const handleAddFollowup = async (e) => {
    e?.preventDefault();
    try {
      const { data } = await axios.post("", {
        action: "addLeadFollowup",
        companyId,
        leadId,
        ...formState,
      });
      if (data?.success) {
        setFollowups((prev) => [
          ...prev,
          { schedule: formState?.scheduleTime, followup: formState.followup },
        ]);
        onClose();
        setFormState({ honorifics: "mr" });
        toast.success(data?.msg);
      } else {
        toast.error(data?.error);
      }
    } catch (err) {
      console.error("ERROR:", err);
    }
  };

  return (
    <Modal {...{ title: "Add Followup Note", onClose, isOpen }}>
      <form onSubmit={handleAddFollowup}>
        <div className="step row gy-4">
          <div className="col-md-6">
            <input
              type="text"
              name="followup"
              value={formState.followup}
              onChange={handleInput}
              className="form-control"
              placeholder="Followup Note"
              required
            />
          </div>
          <div className="col-md-6">
            <input
              type="datetime-local"
              name="scheduleTime"
              value={formState.scheduleTime}
              onChange={handleInput}
              className="form-control"
              placeholder="Phone number"
              required
            />
          </div>
        </div>
        <div className="d-flex mb-n3 pt-3 mt-3 border-top justify-content-end">
          <button type="button" className="btn btn-light me-2">
            Cancel
          </button>
          <button type="submit" className="btn btn-primary">
            Add
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default AddFollowup;
